import React from "react";
import AppRoutes from "./Routes/AppRoutes";
import { Theme } from "./Themes/theme";
import { ThemeProvider } from "@mui/material";

function App() {
  return (
    <ThemeProvider theme={Theme}>
      <AppRoutes></AppRoutes>
    </ThemeProvider>
  );
}

export default App;
